export const sbConfig = {
    serviceInstance: new Object()
}


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/accordion/components/sb.config.ts